import { SHORTCUTS } from './shortcuts';
import { Kbd, Sheet } from './ui';
import { useUi } from './ui-store';
import { tr } from '../lib/i18n';

export function ShortcutsHelp() {
  const { help, set } = useUi();
  return (
    <Sheet open={help} onClose={() => set({ help: false })} title={tr('Keyboard shortcuts')} wide>
      <div className="grid gap-6 pb-2 md:grid-cols-2">
        {SHORTCUTS.map((g) => (
          <section key={g.group}>
            <h3 className="mb-2 text-xs font-bold tracking-[0.08em] text-muted uppercase">{g.group}</h3>
            <dl className="flex flex-col gap-2">
              {g.items.map(([k, d]) => (
                <div key={k} className="flex items-start gap-3 text-sm">
                  <dt className="flex w-32 shrink-0 flex-wrap gap-1">{k.split('  ').map((p) => <Kbd key={p}>{p}</Kbd>)}</dt>
                  <dd className="text-ink">{d}</dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </Sheet>
  );
}
